import { render, staticRenderFns } from "./role-repeater.vue?vue&type=template&id=1c2cf234&"
import script from "./role-repeater.vue?vue&type=script&lang=ts&"
export * from "./role-repeater.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports